// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_3Ak2_zactCm1XAgAsy-JcQ","code":"_39VS0Cd-ZZApxLb46eVOiZ","number":"_3xFYGX8G9FRKmqoX_XVmu7"};